import {makeAutoObservable, reaction} from "mobx";

export class NumberObservable {
  number: number | undefined;
  min: number | undefined;
  max: number | undefined;
  decimalPlaces: number;
  validate?: (toValidate: number | undefined) => boolean;
  isDisabled: boolean;
  isDirty: boolean;
  initialValue: number | undefined;

  constructor(
    number?: number,
    min?: number,
    max?: number,
    decimalPlaces?: number,
    validate?: (toValidate: number | undefined) => boolean,
    disabled?: boolean
  ) {
    makeAutoObservable(this);
    this.number = number;
    this.min = min;
    this.max = max;
    this.decimalPlaces = decimalPlaces ?? 2;
    this.validate = validate;
    this.isDirty = false;
    this.isDisabled = !!disabled;
    this.initialValue = number;

    reaction(
      () => this.number,
      () => this.setIsDirty(true)
    );
  }

  setIsDirty = (value: boolean) => {
    this.isDirty = value;
  };

  get isValid() {
    return (
      this.isDisabled ||
      this.validate == null ||
      !this.isDirty ||
      this.validate(this.number)
    );
  }

  setNumber = (value: number | undefined) => {
    this.number = value;
  };

  setIsDisabled = (value: boolean) => {
    this.isDisabled = value;
  };
}
